import { createContext, useState } from "react";

export const ClienteContext = createContext();
// Se crea un contexto para compartir el ID del cliente seleccionado entre componentes
export const ClienteProvider = ({ children }) => {
  const [idClienteSeleccionado, setIdClienteSeleccionado] = useState("");

  return (
    <ClienteContext.Provider value={{ idClienteSeleccionado, setIdClienteSeleccionado }}>
      {children}
    </ClienteContext.Provider>
  );
};